import {ChangeDetectorRef, Component, forwardRef, Input, OnInit} from '@angular/core';
import {FormBuilder, FormControl} from "@angular/forms";
import {AbstractVisbosControl} from "../../forms/abstract-visbos-control";
import {SessionActions} from "../../../../../shared/actions/session.actions";

@Component({
  selector: 'vb-use-by-date-picker',
  templateUrl: './use-by-date-picker.component.html',
  styleUrls: ['./use-by-date-picker.component.css'],
  providers: [{provide: AbstractVisbosControl, useExisting: forwardRef(() => UseByDatePickerComponent)}]
})
export class UseByDatePickerComponent extends AbstractVisbosControl<any, FormControl> implements OnInit {

  @Input()
  id: string = 'useByDatePickerInput';

  @Input()
  inputGroupClass: string = 'input-group-sm';

  constructor(fb: FormBuilder, cd: ChangeDetectorRef, sessionActions: SessionActions) {
    super(fb, cd, sessionActions);
  }

  ngOnInit() {
    super.ngOnInit();
  }

  buildControlContent(): FormControl {
    return this.fb.control(null);
  }

  public setDefaultValues(item?: any): { [p: string]: any } | any {
    return void 0;
  }

}



// WEBPACK FOOTER //
// ./src/app/core/visbos-core/ui/components/use-by-date-picker/use-by-date-picker.component.ts